import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { formatDateInLocalTimezone } from "@/common/utils/formatters";
import { getFilenameFromUrl } from '@/common/utils/getFilenameFromUrl';
import { EstablishmentInfrastructuresTransformer } from '@/features/maintenance/establishmentInfrastructures/services/establishmentInfrastructuresTransformer';
import { EstablishmentTechnicalProfessionalsTransformer } from '@/features/maintenance/establishmentTechnicalProfessionals/services/establishmentTechnicalProfessionalsTransformer';

export const updateEstablishmentCompanyMaintenanceModelsDefaultValues = (establishmentCompany: EstablishmentCompanyData) => ({
  maintenance_infrastructures: EstablishmentInfrastructuresTransformer.optionsTransformer()(
    establishmentCompany.maintenance_infrastructures?.map(({ infrastructure }) => infrastructure),
  ),
  maintenance_technical_professionals: EstablishmentTechnicalProfessionalsTransformer.optionsTransformer()(
    establishmentCompany.maintenance_technical_professionals?.map(({ technical_professional }) => technical_professional),
  ),
  maintenance_specialty: establishmentCompany.maintenance_specialty ? {
    id: establishmentCompany.maintenance_specialty.id,
  } : undefined,
  maintenance_required_documents_attributes: establishmentCompany.maintenance_required_documents.map((maintenanceRequiredDocument) => ({
    id: maintenanceRequiredDocument.id,
    document: {
      id: maintenanceRequiredDocument.document_id,
      display_name: maintenanceRequiredDocument.document.display_name,
    },
    file_attachment_attributes: {
      file_name: maintenanceRequiredDocument.file
        ? getFilenameFromUrl(maintenanceRequiredDocument.file?.url)
        : undefined,
      file_url: maintenanceRequiredDocument.file?.url,
    },
    valid_until: maintenanceRequiredDocument.valid_until
      ? formatDateInLocalTimezone(maintenanceRequiredDocument.valid_until)
      : undefined,
    issue_date: maintenanceRequiredDocument.issue_date
      ? formatDateInLocalTimezone(maintenanceRequiredDocument.issue_date)
      : undefined,
  })),
});
